// removed by extract-text-webpack-plugin
module.exports = {"container":"LiveStreamsToolbar-container"};